import React from 'react';
import PropTypes from 'prop-types';
import useStyle from './style';

const TabContent = ({
  id,
  children,
  ...rest
}) => {
  const classes = useStyle();

  return (
    <div
      className={classes.tabContent}
      {...rest}
    >
      {children}
    </div>
  );
};

TabContent.propTypes = {
  id: PropTypes.string.isRequired,
};

export default TabContent;
